import { SAVE_SEARCH_FIELD } from '../actions/SearchFieldAction';

const initialState = {
  stationFrom: {},
  stationTo: {}
};

export default function (state = initialState , action) {
  switch (action.type) {
    case SAVE_SEARCH_FIELD:
      return {
        ...action.payload
      }
    default:
      return {
        ...state
      }
  }
}


// WEBPACK FOOTER //
// ./src/reducers/SearchFieldReducer.js